export default {"src":"/_next/static/media/9-icon.0999dc3e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};